import { FC } from 'react';
import { IProductDetailId } from '../../../../../types/products';
import Furniture from './Furniture';
import Laptop from './LapTop';
import Monitors from './Monitors';

interface ITypeProduct {
  id: number;
  type: string;
}

interface IProductForm {
  typeProduct: ITypeProduct;
  numberTab: number;
  productDataDetail?: IProductDetailId;
  setVerifySpecs: (isVerify: boolean) => void;
}

const Specs: FC<IProductForm> = ({ typeProduct, numberTab, productDataDetail, setVerifySpecs }: IProductForm) => {
  const laptopSpecs = [1, 2, 8, 9, 10].includes(typeProduct.id);
  
  return (
    <div style={{ display: numberTab !== 2 ? 'none' : '' }}>
      {laptopSpecs ? (
        <Laptop productDataDetail={productDataDetail} setVerifySpecs={setVerifySpecs} />
      ) : typeProduct.id === 3 ? (
        <Monitors productDataDetail={productDataDetail} setVerifySpecs={setVerifySpecs} />
      ) : (
        <Furniture productDataDetail={productDataDetail} setVerifySpecs={setVerifySpecs} />
      )}
    </div>
  );
};

export default Specs;
